import { useState } from 'react'
import { CSpinner } from '@coreui/react-pro'
import axios from 'axios'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { businessApiURL } from 'src/business/services'
import styled from 'styled-components'
import { ActionBtn } from './MembersPageStyles'

const BulkFormWrap = styled.div`
  font-family: Outfit, sans-serif;
`

const FormField = styled.div`
  margin-bottom: 20px;
`

const FormLabel = styled.label`
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #1a0a4e;
  margin-bottom: 8px;

  .dark-theme & {
    color: rgba(255, 255, 255, 0.9);
  }
`

const FormSelect = styled.select`
  width: 100%;
  padding: 10px 14px;
  font-size: 14px;
  font-family: Outfit, sans-serif;
  color: #1a0a4e;
  background: #fff;
  border: 1px solid rgba(32, 7, 105, 0.12);
  border-radius: 10px;
  outline: none;

  .dark-theme & {
    background: rgba(255, 255, 255, 0.08);
    color: rgba(255, 255, 255, 0.9);
    border-color: rgba(255, 255, 255, 0.12);
  }
`

const SelectedHint = styled.p`
  font-size: 13px;
  color: #5c5c7a;
  margin: 0 0 16px 0;

  .dark-theme & {
    color: rgba(255, 255, 255, 0.6);
  }
`

function BulkActionForm(props) {
  const [packages, setPackages] = useState('')
  const [status, setStatus] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (props.selected?.length === 0) {
      toast.info('Select at least one member.')
      return
    }
    setLoading(true)
    const token = localStorage.getItem('token')
    const body = {
      subscriberIds: props.selected,
      status: status || undefined,
      packageId: packages || undefined,
    }
    try {
      await axios.post(`${businessApiURL}/api/secure/bc/subscriber/update/bulk`, body, {
        headers: { Authorization: `Bearer ${token}` },
      })
      props.updateSubscribers()
      toast.success('Members updated successfully.')
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Update failed.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <BulkFormWrap>
      {loading ? (
        <div style={{ padding: 32, textAlign: 'center' }}>
          <CSpinner />
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <SelectedHint>
            {props.selected?.length > 0 ? `Updating ${props.selected.length} member(s)` : 'Select members from the table to perform bulk updates.'}
          </SelectedHint>

          <FormField>
            <FormLabel htmlFor="bulkPackages">Package</FormLabel>
            <FormSelect
              id="bulkPackages"
              value={packages}
              onChange={(e) => setPackages(e.target.value)}
            >
              <option value="">Keep current</option>
              <option value="SPN-0000531f46a344d2bee9b68e9761cac7">Package 1 day pass</option>
            </FormSelect>
          </FormField>

          <FormField>
            <FormLabel htmlFor="bulkStatus">Status</FormLabel>
            <FormSelect
              id="bulkStatus"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="">Keep current</option>
              <option value="active">Active</option>
              <option value="expire">Expired</option>
              <option value="renew">Renew</option>
            </FormSelect>
          </FormField>

          <ActionBtn type="submit" className="primary" disabled={!props.selected?.length}>
            Update
          </ActionBtn>
        </form>
      )}
    </BulkFormWrap>
  )
}

export default BulkActionForm
